import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cursos/personas/")({
  beforeLoad: () => {
    throw redirect({ to: "/cursos/personas/convenio-umayor" });
  },
});
